export default __webpack_public_path__ + "static/media/12.07412545.jpg";